import { createContext, useContext } from "react";
import { FilterField } from "../config/filter";

export type TimeGrainOverride = "day" | "week" | null;

export interface ControlContextType {
  filterField: FilterField | undefined;
  filterValue: string;
  usePercent: boolean;
  timeRange: { start: Date | null; end: Date | null };
  grainOverride: TimeGrainOverride;
  setFilterField: (field: FilterField | undefined) => void;
  setFilterValue: (value: string) => void;
  setUsePercent: (value: boolean) => void;
  setTimeRange: (range: { start: Date | null; end: Date | null }) => void;
  setGrainOverride: (grain: TimeGrainOverride) => void;
  clearFilter: () => void;
}

export const ControlContext = createContext<ControlContextType | undefined>(undefined);

export function useControl(): ControlContextType {
  const context = useContext(ControlContext);
  if (context === undefined) {
    throw new Error("useControl must be used within a ControlProvider");
  }
  return context;
}
